module.exports = __webpack_public_path__ + "img/9788975276293.9ee5b1b2.jpg";